import PropTypes from 'prop-types';
import FJSwitchButton from '../../../common/components/FJSwitchButton/FJSwitchButton';

import styles from './FJSwitchCard.module.less';
import classNames from 'classnames';
const FJSwitchCard = props => {
    const { active, text, onChange, className, style, disabled } = props;
    return (
        <div className={classNames(styles.card, className, disabled && styles.disabled)} style={style}>
            <div className={styles.text}>{text}</div>
            <FJSwitchButton active={active} onChange={onChange} />
        </div>
    );
};
FJSwitchCard.propTypes = {
    active: PropTypes.bool,
    text: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default FJSwitchCard;
